export const logoutSetReturnUrl = () => {
  try {
    localStorage.setItem('returnUrl', window.location.href);
    window.location.href = '/api/sso-login';
  } catch (error) {
    console.error('Can not set return URL', error);
  }
};
